function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.833 6.25h10.834c.46 0 .833.433.833.968v11.915a.5.5 0 01-.75.433L6.45 16.498a.5.5 0 00-.504.002L.754 19.557A.5.5 0 010 19.126V7.218c0-.535.373-.968.833-.968z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 11.114V4.718c0-.535-.373-.968-.833-.968H8.333c-.833 0-.833-.535-.833-1.227V.968C7.5.433 7.873 0 8.333 0h10.834c.46 0 .833.433.833.968v13.01a.5.5 0 01-.807.395L15 11.113z"
});

function SvgCollections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgCollections;